import { useOrgId } from './useOrg';

const useShowCompanyLabelFlag = () => {
  const orgId = useOrgId();
  return !(orgId === 1 || orgId === 2);
};

export default useShowCompanyLabelFlag;
